import styled from 'styled-components';
import { Modal, Spin } from 'antd';

export const ChangeColorModalStyled = styled(Modal)`
    width: 680px !important;

    .ant-modal-body {
        padding: 32px 40px 40px 40px;
    }

    .ant-modal-content {
        border-radius: 6px;
    }

    .ant-divider-horizontal {
        margin-top: 28px;
        margin-bottom: 21px;
    }
`;

export const ChangeColorSpin = styled(Spin)`
    top: 0 !important;
`;

export const TagNamesList = styled.div`
    margin: 12px 0 16px 0;
    font-size: 14px;
    line-height: 22px;
`;

export const ModalContent = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;